import { render, staticRenderFns, recyclableRender, components } from "./change-binding.vue?vue&type=template&id=52299874&scoped=true&"
var renderjs
import script from "./change-binding.vue?vue&type=script&lang=js&"
export * from "./change-binding.vue?vue&type=script&lang=js&"
import style0 from "./change-binding.vue?vue&type=style&index=0&id=52299874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52299874",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/change-binding/change-binding.vue"
export default component.exports